import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getFaq } from "../../store/actions/faqs_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/faqs_enum";
import SingleView from "../../components/common/SingleView";
const ViewFaq = ({ getFaq, match, faq: { loading, faq } }) => {
  useEffect(() => {
    getFaq(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Faqs"
          mainLinkTitle="Faqs"
          mainLinkUrl="/faqs"
          activeLink="View"
        />
        {!loading ? (
          faq && (
            <SingleView
              data={faq}
              inputFields={inputFields}
              label="Faq"
              link="faqs"
              id={faq.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ faq: state.faq });

const mapDispatchToProps = { getFaq };

export default connect(mapStateToProps, mapDispatchToProps)(ViewFaq);
